import { getCurrentOrganizationId } from './Organization';

const ONBOARDING_COMPLETED_EVENT = 'Onboarding Completed';

export const newOnboardingCompletedEvent = () => ({
  objectType: 'organization',
  objectId: getCurrentOrganizationId(),
  name: ONBOARDING_COMPLETED_EVENT
});
